module.exports = __webpack_public_path__ + "img/denmark-leukaemia-female.32116fb1.png";